import { Grid, Typography } from '@mui/material';

interface ColorDescriptionProps {
  colorDescription: string;
  color: string;
}

export const ColorDescription = (props: ColorDescriptionProps) => {
  return (
    <Grid container alignItems={'center'} marginLeft={'0.5em'}>
      <div
        style={{
          width: '2em',
          height: '2em',
          background: props.color,
          borderRadius: 100,
          margin: '0.25em'
        }}
      ></div>
      <Typography>{props.colorDescription}</Typography>
    </Grid>
  );
};
